var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"years-input"},[_c('div',{staticClass:"years-input-padding"},[_c('input',{ref:"input",attrs:{"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.updateValue($event.target.value)},"focus":_vm.selectAll,"blur":_vm.formatValue}})]),_vm._v(" "),_c('label',[_vm._v("Yrs.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }